import React, { CSSProperties, ReactNode } from 'react'
import styles from './Radio.module.sass'
import clsx from 'clsx'

interface Props<Item> {
    className?: string,
    value?: Item,
    items: Item[],
    toKey: (item: Item) => number | string,
    toColor?: (item: Item) => string,
    render: (item: Item) => ReactNode,
    onChange?: (value: Item) => void,
}

function Radio<Item>(props: Props<Item>): JSX.Element {
    return <div className={clsx(props.className, styles.group)}>
        {
            props.items.map(item => <div
                key={props.toKey(item)}
                className={clsx(styles.radio, {
                    [styles.active]: props.value !== undefined && (props.toKey(props.value) === props.toKey(item))
                })}
                onClick={() => props.onChange?.(item)}
                style={{'--color': props.toColor?.(item)} as CSSProperties}
            >
                <div className={styles.circle}/>
                <div>{props.render(item)}</div>
            </div>)
        }
    </div>
}

export default Radio